import React from 'react';
import styles from './Advt.module.css';
import { useGetParams } from '../../hooks/useGetParams';

import { motion } from 'framer-motion';

const Advt = React.memo(() => {
  const { qrCode1, qrCode2, title, sizeQR, titleFontSize } = useGetParams();

  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 0.5, delay: 0.6 }}
      className={styles.wrapper}
    >
      {title && (
        <div
          className={styles.title}
          style={{ fontSize: `${titleFontSize}rem` }}
        >
          {title}
        </div>
      )}

      <div className={styles.qrBlock}>
        {qrCode1 && (
          <div
            className={styles.qrCode}
            style={{ width: `${sizeQR}rem`, height: `${sizeQR}rem` }}
          >
            <img src={qrCode1} alt="qrCode1" />
          </div>
        )}
        {qrCode2 && (
          <div
            className={styles.qrCode}
            style={{ width: `${sizeQR}rem`, height: `${sizeQR}rem` }}
          >
            <img src={qrCode2} alt="qrCode1" />
          </div>
        )}
      </div>
    </motion.div>
  );
});

export default Advt;
